import type { CSSProperties } from 'react';
import type { BrandIcon } from '@/lib/simpleIcons';

type Props = {
  icon: BrandIcon;
  title?: string;
  className?: string;
  style?: CSSProperties;
  size?: number | string;
};

/** Renders a Simple Icons SVG path (currentColor). */
export function SimpleIcon({ icon, title, className, style, size = '1em' }: Props) {
  return (
    <svg
      role="img"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      className={className}
      style={style}
      aria-hidden={title ? undefined : true}
      aria-label={title}
    >
      {title ? <title>{title}</title> : null}
      <path d={icon.path} fill="currentColor" />
    </svg>
  );
}
